<template>
  <div class="mgt5 mgb15"
       style="text-align: center">
    <img src="@/assets/img/common/img-gnb-logo.png"
         alt="SEROI" />
  </div>
  <div class="join-stage-con mgt5">
    <div class="join-stage-tab">
      <ul class="tabmenu">
        <li v-for="{se, nm} in tabs"
            :key="'tab_'+se"
            :class="selTabSe == se ? 'current' : ''">
          <a href="javascript:;"
             @click="btnTab_click(se)">{{ nm }}</a>
        </li>
      </ul>
      <div class="tab-container">
        <div class="tab-content">
          <div class="join-find">
            <id-find v-if="selTabSe == 'id'"
                     @chng-tab="btnTab_click('pswd')"
                     @close="emits('close')"/>
            <pswd-find v-if="selTabSe == 'pswd'"
                       @close="emits('close')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits} from "vue";
import IdFind from "@/views/lgin/id-find.vue";
import PswdFind from "@/views/lgin/pswd-find.vue";

const emits = defineEmits(['close']);

const selTabSe = ref('id');
const tabs = ref([
  {se: 'id', nm: '아이디 찾기'},
  {se: 'pswd', nm: '비밀번호 찾기'},
]);

const btnTab_click = (se) => {
  selTabSe.value = se;
}
</script>

<style scoped>

</style>
